// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"d875381f","161":"2ece130c","404":"185cb0f9","513":"be716c2b","746":"d4083108"}[chunkId] + ".chunk.js";
};